// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EI2r","col":"styles_col__1fq5j"};